import { render, staticRenderFns } from "./BetslipPossibleWin.vue?vue&type=template&id=128876f4&scoped=true"
import script from "./BetslipPossibleWin.vue?vue&type=script&lang=js"
export * from "./BetslipPossibleWin.vue?vue&type=script&lang=js"
import style0 from "./BetslipPossibleWin.vue?vue&type=style&index=0&id=128876f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128876f4",
  null
  
)

export default component.exports